import * as moment from 'moment';
import { forkJoin, Observable } from 'rxjs';
import { DatePipe, formatDate } from "@angular/common";
import { MatDialog } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { CommonService } from "src/app/Service/Common.service";
import { RestApiService } from 'src/app/Service/rest-api.service';
import { LoaderService } from 'src/app/Service/Loader/loader.service';
import { RoleFeatureModel } from 'src/app/ViewModel/RoleFeatureModel';
import { NotificationService } from "src/app/Service/notification.service";
import { ChecklistService } from 'src/app/Service/checklist/checklist.service';
import { EncryptDecryptService } from 'src/app/Service/encrypt-decrypt.service';
import { Component, Input, OnInit, ElementRef, Output, EventEmitter } from "@angular/core";
import { RespondWorkflowListModel } from 'src/app/ViewModel/RespondWorkflowModel';
import { WorkflowTemplateDialogModel } from 'src/app/ViewModel/WorkflowTemplateDialogModel';
import { FileUploadComponent } from 'src/app/CommonComponents/file-upload/file-upload.component';
import { WorkflowTemplateService } from 'src/app/Service/workflow-template/workflow-template.service';
import { RespondWorflowChecklistItemsComponent } from '../respond-worflow-checklist-items/respond-worflow-checklist-items.component';
import { RespondWorflowComponent } from '../../respond-worflow/respond-worflow.component';
import { ForgeViewerComponent } from 'src/app/CommonComponents/forge-viewer/forge-viewer.component';
import { CreateTransmittalComponent } from 'src/app/Modules/transmittal/transmittal-creation/transmittal-creation.component';
import { WFActionAssignedToComponent } from '../wft-action-assignto/wft-action-asssignto.component';
import { WorkflowActionModel, IWFDocCategoryModel, IDCINoOfSheetsModel } from 'src/app/ViewModel/WorkflowActionModel';
import { WorkflowTemplateStatusInputModel } from 'src/app/ViewModel/WorkflowTemplateStatusInputModel';
import { WorkflowAssignedToModel } from 'src/app/ViewModel/WorkflowAssignedToModel';
import { WorkflowTenderQuantityComponent } from '../workflow-tender-quantity/workflow-tender-quantity.component';
import { ProjectInfoService } from 'src/app/Service/project-info/project-info.service';
import { IDCIRevisionMaster, IProjectElementDetailsOutput, IProjectElementsOutput } from 'src/app/ViewModel/ProjectElementsModel';
import { Module } from "src/app/Service/element-details.data.service";
import { StandardOutputModel } from 'src/app/ViewModel/StandardOutputModel';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { IDCISupersedeRevDetailsModel, IDelayReason, IRevisionCategory, IScheduleDocInfo, ILatestStageDetails } from 'src/app/ViewModel/ScheduleDocumentModel';
import { ScheduleDocumentService } from 'src/app/Service/scheduledocument/scheduleDocument.service';
import { FileService, FileUploadLibrary } from 'src/app/Service/file/file.service';
import { ScheduleWorkflowhistoryComponent } from 'src/app/Modules/engineering-schedule/schedule-workflowhistory/schedule-workflowhistory.component';
import { DocumentPreviousRevisionChecklistComponent } from '../document-previous-revision-checklist/document-previous-revision-checklist.component';
import { anyChanged } from '@progress/kendo-angular-common';
import { DocumentRevisionLinkService } from "src/app/Service/document-revision-link/document-revision-link.service";
import { isNumber } from 'lodash';

@Component({
    selector: 'app-respond-worflow-action',
    templateUrl: './respond-worflow-action.component.html',
    styleUrls: ['./respond-worflow-action.component.css']
})
export class RespondWorflowActionComponent implements OnInit {

    @Input() public selectedToggle: any;
    @Input() parentfu!: RespondWorflowComponent;
    @Input() public isBulkAction!: boolean;
    @Output() closeTab = new EventEmitter();
    @Output() CopyDetails = new EventEmitter<any>();
    public index = 0;
    public prevIndex = 0;
    public nextIndex = 0;
    public isMatValue = 'S';
    public member: any = null;
    public isMaterial = false;
    public tabsArray: any = [];
    public groupId: number = 0;
    public memberId: number = 0;
    public projectId: number = 0;
    public carouselItemTransform = 0;
    public CarouselItemTransform = 0;
    public isChecklistRequired = false;
    public isPeerReviewRequired = false;
    public selectedChecklist: number = 0;
    public checklistCollection: any = [];
    public isAttachmentRequired = false;
    public isTransmittalRequired = false;
    public isDTNPreparation = false;
    public isDTNRelease = false;
    public isCCNRequired = false;
    public isDocstatusChangesRequired = false;
    public setclear: any;
    isShowICSpecific: boolean = false;
    public addCheckList: boolean = false;
    public isCommentSheetRequired = false;
    public isCommentSheetno: string | null = null;
    public isTenderQuantityRequired = false;
    public isTenderQuantityApprovalRequired = false;
    public _wfDetails!: RespondWorkflowListModel;
    public fileTypeList: RoleFeatureModel[] = [];
    public Checklist: string = "A";
    public fileCollection: Array<any> = new Array<any>();
    public workflowIntegrateToList: RoleFeatureModel[] = [];
    statusList: RoleFeatureModel[] = [];
    public currentWorkflowDetails!: WorkflowTemplateDialogModel;
    public currentTask: any;
    public selectedChecklistCollection: Array<any> = new Array<any>();
    public getpopupValue: any = [];
    public checkListApplicable!: boolean;
    public getTQpopupvalue: boolean = false;
    public isCompletedOnManul: boolean = false;
    public isCompletedOnManulRequired = false;
    public isApprovalStatusRequired = false;
    public isNoOfSheetsRequired = false;
    public supersedeActions: WorkflowActionModel[] = [];
    public defaultDateValue = new Date(this.getFormattedDate(new Date()));
    public selectedCompletedOnDate = this.getFormattedDate(new Date());
    public min: Date = new Date(2002, 2, 10);
    public today: Date = new Date();
    public dueOn!: Date;
    public isDueOnRequired: boolean = false;
    public isDelayed: boolean = false;
    public max: Date = new Date(this.getFormattedDate(new Date()));
    public isQuantityApplicable: string = "A";
    public action_id: any;
    public show: boolean = true;
    revForm!: FormGroup;
    drForm!: FormGroup;
    icIsDisabled: boolean = true;
    IsShow: boolean = false;
    getworkflowHistoryvalue: any[] = [];
    public delayReasonDD!: number | undefined;
    public delayReasonValid: any;
    revCategoryList: IRevisionCategory[] = [];
    delayReasonList: IDelayReason[] = [];
    printSizeList: IProjectElementDetailsOutput[] = [];
    dciStatusList: IProjectElementDetailsOutput[] = [];
    docCategoryList: IProjectElementDetailsOutput[] = [];
    ProgressLevelsList: IProjectElementDetailsOutput[] = [];
    selectedDocCategoryValue: number = 0;
    SelectedProgressLevel: number = 0;
    public reciviedChecklist: any[] = [];
    projectStaticElements: IProjectElementsOutput[] = [];
    isDocSetRequired: boolean = true;
    LatestStageDetails: ILatestStageDetails[] = [];
    previouswithvalue: any[] = [];
    PreviousChecklist: any[] = [];
    public checklistselectedvalue: any[] = [];
    public isForReAssignment!: boolean;
    public ListofActiondetails: any[] = [];
    public Actiondetails: any;
    public pageSize: number = 20;
    public Postobj!: any[];
    public holdReason: string | null = null;
    holded: boolean = false;
    is_checklistCopied: boolean = false;
    showholdTextinput: boolean = false;
    Can_Update_DCI_Progress_Level: boolean = false;
    dciRevisionList: IDCIRevisionMaster[] = [];
    public current_subWf: number = 0;
    public next_subWf: number = 0;
    public supersede_enabled : boolean = false;
    public current_RevNo: string = null;
    public next_RevNo: string = null;
    public stageChange: boolean = false;
    get wfInputDetails(): RespondWorkflowListModel {
        return this._wfDetails;
    }

    @Input() set wfDetails(value: RespondWorkflowListModel) {
        if (!!value && typeof value == "object") {
            this._wfDetails = value;
            this._wfDetails["comments"] = null;
            this._wfDetails["delayReason"] = null;
            this._wfDetails["internalReason"] = null;
            this._wfDetails["externalReason"] = null;
        }
    }

    constructor(private http: HttpClient, private encryptDecryptService: EncryptDecryptService,
        private loaderService: LoaderService, private restApiService: RestApiService,
        private dialog: MatDialog, private elem: ElementRef, public _notificationService: NotificationService,private _dciRevMaster: DocumentRevisionLinkService,
        public _commonService: CommonService, public _datepipe: DatePipe, public workflowTemplateService: WorkflowTemplateService,
        public checklistService: ChecklistService, private _projService: ProjectInfoService, private _formBuilder: FormBuilder, private _dciService: ScheduleDocumentService, private _fileService: FileService) {
    }

    ngOnInit() {
        
        this.projectId = this._commonService.getProjectId();
        this.memberId = this._commonService.getLoggedInUserId();
        this.groupId = this._commonService.getLoggedInUserGroupId();
       
        this.min = new Date(this.getFormattedDate(this.wfInputDetails.assignedOn));
        let _Charcode:number =this.wfInputDetails.revisionNo.charCodeAt(this.wfInputDetails.revisionNo.length - 1);
        let revision_No;
        if(!isNaN(Number(this.wfInputDetails.revisionNo)))
        {
             revision_No = String(Number(this.wfInputDetails.revisionNo)+ 1);        
        }
        else{
         revision_No = this.wfInputDetails.revisionNo.substring(0, this.wfInputDetails.revisionNo.length - 1) +
            String.fromCharCode(this.wfInputDetails.revisionNo.charCodeAt(this.wfInputDetails.revisionNo.length - 1) + 1);
        }
            this.revForm = this._formBuilder.group({
            printSize: new FormControl('', Validators.required),
            formPrintSize: new FormControl('', Validators.required),
            revCategory: new FormControl('', Validators.required),
            formrevCategory: new FormControl('', Validators.required),
            dciStatus: new FormControl('', [Validators.required]),
            formDciStatus: new FormControl('', [Validators.required]),
            comments: new FormControl(),
            noOfSheets: new FormControl(),
            docStatus: new FormControl(),
            formRevision: new FormControl(revision_No, [Validators.required])
        });
        this.getStatusList();
        this.getElementDetails("Print Size");
        this.getElementDetails("Document Category");
        this.getElementDetails("Status");
        this.getElementDetails("Progress Level", Module.Workflow);
        this.getProjectStaticElements();
        this.drForm = this._formBuilder.group({
            delayReasonDD: new FormControl('', Validators.required),
            txtDRC: new FormControl('', Validators.required),
            txtIRC: new FormControl('', Validators.required),
            txtERC: new FormControl('', Validators.required),
        });
        this.delayReasonList = [{ delayReasonId: 1, delayReason: 'Delay Reason' }, { delayReasonId: 2, delayReason: 'Internal Reason' }, { delayReasonId: 3, delayReason: 'External Reason' }];
        forkJoin(this.workflowTemplateService.getCommonDEDAgainstDE("Workflow IntegrateTo"), this.workflowTemplateService.getWorkflowTemplate(this.wfInputDetails.workflowId)).subscribe(res => {
            this.workflowIntegrateToList = res[0];
            this.currentWorkflowDetails = res[1];
            

            let wfact = this.currentWorkflowDetails.workflowAction.some(x => x.action_Description == 'Hold' && x.task_Id == this.wfInputDetails.currentTaskId);
            if (wfact && !this.holded)
                this.showholdTextinput = true;
            let currentTask = this.currentWorkflowDetails.workflowStatus.filter(item => item.sub_Workflow == this.wfInputDetails.subWorkflow && item.workflow_Status_Description.toUpperCase().trim() == this.wfInputDetails.taskName.toUpperCase().trim())[0];
            this.currentTask = currentTask;
            if (this.currentWorkflowDetails && this.currentWorkflowDetails.workflowAction.length > 0 && this.wfInputDetails) {
                this.ListofActiondetails = this.currentWorkflowDetails.workflowAction.filter(x => x.task_Id == this.wfInputDetails.currentTaskId)

                if (currentTask.integration_Type == null && this.ListofActiondetails && this.ListofActiondetails.length > 0) {
                    if (this.ListofActiondetails.filter(x => x.action_Description == "Approve").length > 0)
                        this.action_id = this.ListofActiondetails.filter(x => x.action_Description == "Approve")[0].action_Id
                }
            }
            this.isForReAssignment = this.currentWorkflowDetails.isForReAssignment;
            //Get the current workflow step actions & ensure that any of the action is invovled in supersede operation
            let workflowActions: WorkflowActionModel[] = this.currentWorkflowDetails.workflowAction.filter(x => x.task_Id == currentTask.task_Id);

            if (!!workflowActions && workflowActions.length > 0) {
                this.supersedeActions = workflowActions.filter(wc => wc.enable_Tag);

                let v = this.currentWorkflowDetails.workflowAction.filter(x => x.enable_Tag && x.task_Id == this.currentTask.task_Id);

                let SupersedeSubWorkflows = v.map(item => item.next_Step_Sub_Workflow)
                    .filter((value, index, self) => self.indexOf(value) === index).join(',');


                let obj = {
                    "Doc_Id": this.wfInputDetails.documentId,
                    "Stage_Ids": SupersedeSubWorkflows
                }
                this.workflowTemplateService.GetWorkflowLatestStageDetail(obj).subscribe(data => {
                    if (!!data) {
                        this.LatestStageDetails = data.map((x: any) => { x.scheduled_On = new Date(x.scheduled_On), x.revisedScheduled_On = (x.revisedScheduled_On ? new Date(x.revisedScheduled_On) : null), x.minScheduled_On = (x.minScheduled_On ? new Date(x.minScheduled_On) : null), x.maxScheduled_On = (x.maxScheduled_On ? new Date(x.maxScheduled_On) : null); return x });
                    }
                })
            }

            this.isCompletedOnManulRequired = this.isCompletedOnManul = currentTask.is_Completed_On_Manual;
            this.isApprovalStatusRequired = currentTask.is_Approval_Status;
            this.isDueOnRequired = currentTask.is_Due_On;
            this.isNoOfSheetsRequired = currentTask.is_No_Of_Sheets_Required;
            this.isCCNRequired = currentTask.is_CCN_Required;
            this.Can_Update_DCI_Progress_Level = currentTask.can_Update_DCI_Progress_Level;

            if (currentTask.integration_Type != null && this.getWorkflowIntegrateToName(currentTask.integration_Type).toUpperCase().trim() === 'Attachment'.toUpperCase().trim()) {
                this.isAttachmentRequired = true;
            }

            if (currentTask.integration_Type != null && this.getWorkflowIntegrateToName(currentTask.integration_Type).toUpperCase().trim() === 'Checklist'.toUpperCase().trim()) {
                this.isChecklistRequired = true;
            }

            if (currentTask.integration_Type != null && this.getWorkflowIntegrateToName(currentTask.integration_Type).toUpperCase().trim() === 'Tender Quantity'.toUpperCase().trim()) {
                this.isTenderQuantityRequired = true;
            }

            if (currentTask.integration_Type != null && this.getWorkflowIntegrateToName(currentTask.integration_Type).toUpperCase().trim() === 'Tender Quantity Approval'.toUpperCase().trim()) {
                this.isTenderQuantityApprovalRequired = true;
            }

            if (currentTask.integration_Type != null && this.getWorkflowIntegrateToName(currentTask.integration_Type).toUpperCase().trim() === 'Checklist + Tender Quantity'.toUpperCase().trim()) {
                this.isChecklistRequired = true;
                this.isTenderQuantityRequired = true;
            }

            if (currentTask.integration_Type != null && this.getWorkflowIntegrateToName(currentTask.integration_Type).toUpperCase().trim() === 'Comment Sheet'.toUpperCase().trim()) {
                this.isCommentSheetRequired = true;
            }

            if (currentTask.integration_Type != null && this.getWorkflowIntegrateToName(currentTask.integration_Type).toUpperCase().trim() === 'Peer Review'.toUpperCase().trim()) {
                this.isPeerReviewRequired = true;
            }

            if (currentTask.integration_Type != null && this.getWorkflowIntegrateToName(currentTask.integration_Type).toUpperCase().trim() === 'Transmittal'.toUpperCase().trim()) {
                this.isTransmittalRequired = true;
            }

            if (currentTask.integration_Type != null && this.getWorkflowIntegrateToName(currentTask.integration_Type).toUpperCase().trim() === 'DTN Preparation'.toUpperCase().trim()) {
                this.isDTNPreparation = true;
            }

            if (currentTask.integration_Type != null && this.getWorkflowIntegrateToName(currentTask.integration_Type).toUpperCase().trim() === 'DTN Release'.toUpperCase().trim()) {
                this.isDTNRelease = true;
            }

            if (this.isDueOnRequired) {
                this.dueOn = this.wfInputDetails.dueOn;
                let doDate = formatDate(this.dueOn, 'yyyy-MM-dd', 'en-US');
                let today = formatDate(this.today, "yyyy-MM-dd", 'en-US');
                if (today > doDate) {
                    this.isDelayed = true;
                }
                else {
                    this.isDelayed = false;
                }
            }

            this.getFileType();
            this.populateFileUploadGrid();

            if (this.isChecklistRequired) {
                this.populateChecklistGrid();
                this.getCheckList(this.wfInputDetails.groupId, this.wfInputDetails.documentDisciplineId, null, null, this.projectId);
            }

            this.setDynamicPosition();
        });
        this.initializeReviseRevisionForm();
        this.getWf_History();

        let obj = {
            "projectId": this.projectId,
            "groupId": this.groupId,
        }
        this._dciRevMaster.getDocumentRevision(obj).subscribe((data: IDCIRevisionMaster[]) => {
            this.dciRevisionList = data;
        });
    }

    getWf_History() {
        if (!!this._wfDetails.documentId) {
            this._dciService.getWorkflowHistory(this._wfDetails.documentId).subscribe((data: any[]) => {
                if (data[0].is_On_Hold) {
                    this.holded = true;
                    this.showholdTextinput = false;
                }
                this.getworkflowHistoryvalue = [];
                data.sort((a, b) => a - b);
                this.getworkflowHistoryvalue.push(data[1]);
                if (data.length > 1) {
                    this.IsShow = true;
                }
            })
        }
    }

    public setDynamicPosition() {
        let index!: number;
        for (let i = 0; i < this.currentWorkflowDetails.workflowStatus.length; i++) {
            if (this.currentWorkflowDetails.workflowStatus[i].sub_Workflow == this.wfInputDetails.subWorkflow && this.currentWorkflowDetails.workflowStatus[i].workflow_Status_Description.toUpperCase().trim() === this.wfInputDetails.taskName.toUpperCase().trim()) {
                index = i;
                break;
            }
        }
        if (index && index > 3) {
            let rootElement: HTMLElement | null = document.getElementById('carousel-container');
            if (rootElement != null) {
                let taskDivs: any = rootElement.children[0].children;
                if (!!taskDivs && taskDivs.length > 0) {
                    rootElement.scrollLeft = taskDivs.item(index).getBoundingClientRect().left - 70;
                }
            }
        }
    }

    public initializeReviseRevisionForm() {
        this.revCategoryList = [{ revCategoryId: 1, revCategory: 'Minor' }, { revCategoryId: 2, revCategory: 'Major' }, { revCategoryId: 3, revCategory: 'First Release' }];
        if (!!this.wfInputDetails.revisionCategory) {
            let revisionCategory = this.revCategoryList.filter(data => data.revCategoryId == this.wfInputDetails.revisionCategory)[0];
            this.revForm.get('formrevCategory')?.setValue(revisionCategory.revCategory);
            this.revForm.get('revCategory')?.setValue(revisionCategory);
        }
    }

    getReviseRevisionDetailsHeader(): string {
        let result: string = "Revise revision details required for ";
        let actions: string = "";
        this.supersedeActions.forEach(x => {
            //Action which all are having supersede option
            if (x.enable_Tag) {
                actions += actions.length == 0 ? x.action_Description : "/" + x.action_Description;
            }
        })
        return result + "<b>" + actions + "</b>";
    }

    onselectedValueChange(val: any, formGroupName: string, formControlName: string) {
        switch (formGroupName) {
            case "revForm":
                this.revForm.get(formControlName)?.setValue(val.additionalValues.additionalValues);
                break;
            case "drForm":
                if (!!val.additionalValues.additionalValues) {
                    this.drForm.get(formControlName)?.setValue(val.additionalValues.additionalValues.delayReason);
                    if (val.value > 0) {
                        this.delayReasonDD = val.value;
                    }
                }
                else {
                    this.delayReasonDD = undefined;
                }
                break
        }
    }

    public rightMove() {
        let _x: any = document.getElementById('carousel-container');
        if (_x)
            _x.scrollLeft += 100;
    };

    public leftMove() {
        let _x: any = document.getElementById('carousel-container');
        if (_x)
            _x.scrollLeft -= 100;
    };

    public onWheel(event: WheelEvent): void {
        let _x: any = document.getElementById('carousel-container');
        if (_x)
            _x.scrollLeft += event.deltaY;
        event.preventDefault();
    }

    public closeTabClick(getIndex: any) {
        this.tabsArray.splice(getIndex, 1);
    }

    public getCompletedOnValue(selectedText: any) {
        this.selectedCompletedOnDate = selectedText.value;

    }

    public getTimeValue(selectedText: any) {
    }

    public getCheckList(businessGroupId: number, disciplineId: number, buid: number | null, icid: number | null, projectId: number) {
        this.checklistService.getChecklist(businessGroupId, disciplineId, buid, icid, projectId, true, true, this.isShowICSpecific).subscribe((data) => {
            data.forEach((each: any) => {
                each['clFullDescription'] = each['clShortDescription'] + ' - ' + each['clDescription'];
            });
            this.checklistCollection = data;
        });
    }

    public getFormattedDate(date: any): string {
        let res: string = "";
        if (date != null)
            res = (moment(date)).format('DD-MMM-yyyy');
        return res;
    }

    public getStatusList() {
        this.workflowTemplateService.getWorkflowTaskList(this.groupId, Module.Workflow, "Workflow", null, "Workflow Status", null, null, this.projectId).subscribe(data => {
            this.statusList = data;
        });
    }

    public getWorkflowStatusName(id: number) {
        if (this.statusList.filter(item => item.dedId == id).length > 0)
            return this.statusList.filter(item => item.dedId == id)[0]["dedDescription"];
        else
            return '';
    }

    public getWorkflowIntegrateToName(id: number) {
        if (this.workflowIntegrateToList.filter(item => item.dedId == id).length > 0)
            return this.workflowIntegrateToList.filter(item => item.dedId == id)[0]["dedDescription"];
        else
            return '';
    }

    public getFileType() {
        this.workflowTemplateService.getCommonDEDAgainstDE("File Type").subscribe(data => {
            this.fileTypeList = data;
        });
    }

    public getFileTypeName(id: number) {
        if (this.fileTypeList.filter(item => item.dedId == id).length > 0)
            return this.fileTypeList.filter(item => item.dedId == id)[0]["dedDescription"];
        else
            return '';
    }

    public attachmentClick() {
        if (this.wfInputDetails.schedule_Type != 3) {
            const dialog = this.dialog.open(FileUploadComponent, {
                panelClass: 'mat-dialog-secondary',
                width: '50%',
                data: { projectId: this.projectId, docId: this.wfInputDetails.documentId, revisionNo: this.wfInputDetails.revisionNo, moduleName: 'EDMS', libraryName: FileUploadLibrary.WorkflowDocument, createdBy: this.memberId, documents: [{ value: this.wfInputDetails.documentId, text: this.wfInputDetails.documentNumber, revisionNo: this.wfInputDetails.revisionNo, task_SNo: this.wfInputDetails.taskSerialNumber }], isEditable: false },
            });
            dialog.afterClosed().subscribe((res: any) => {
                this.populateFileUploadGrid();
            });
        }
        else {
            this._notificationService.showToast("No addtional attachment provided for Standard Drawing documents", "Warning");
        }
    }

    public populateFileUploadGrid() {
        if (this.currentTask.is_SignedCopy_Required == true) {
            let transmittalFileInput: any = {
                projectId: this.projectId,
                messageId: null,
                docId: this.wfInputDetails.documentId,
                revisionNo: this.wfInputDetails.revisionNo
            }
            this._fileService.GetFiles({ libraryNumber: 5, value: JSON.stringify(transmittalFileInput) })
                .subscribe((data: any[]) => {
                    let returnData = data;
                    this.fileCollection = [];
                    for (let index = 0; index <= data.length; index++) {
                        this.fileCollection.push({
                            serial: index + 1,
                            fileId: returnData[index].fileId,
                            fileName: returnData[index].fileName,
                            fileSize: returnData[index].fileSize,
                            fileExtension: returnData[index].fileExtension,
                            fileFullName: returnData[index].fileName + '.' + returnData[index].fileExtension,
                            uploadedBy: returnData[index].createdBy,
                            uploadedByName: returnData[index].createdByName,
                            uploadedOn: this.getFormattedDate(returnData[index].createdOn),
                            fileType: returnData[index].fileType,
                            fileTypeName: this.getFileTypeName(returnData[index].fileType),
                            isDeleteEnable: (returnData[index].task_SNo == this._wfDetails.taskSerialNumber) && (returnData[index].createdBy == this.memberId) ? true : false, // (returnData[index].createdBy == this.memberId) ? true : false, //(each.taskSerialNumber==this._wfDetails.taskSerialNumber)?true:false; 
                            urn: returnData[index].urn,
                            isStandardDrawingDocument: returnData[index].isStandardDrawingDocument
                        });
                    }
                });

        } else {
            let fileInput = {
                projectId: this.projectId,
                docId: this.wfInputDetails.documentId,
                revisionNo: this.wfInputDetails.revisionNo
            }
            this._fileService.GetFiles({ libraryNumber: FileUploadLibrary.WorkflowDocument, value: JSON.stringify(fileInput) }).subscribe(
                data => {
                    this.fileCollection = [];
                    let returnData = data;
                    for (let index = 0; index < returnData['length']; index++) {
                        this.fileCollection.push({
                            serial: index + 1,
                            fileId: returnData[index].fileId,
                            fileName: returnData[index].fileName,
                            fileSize: returnData[index].fileSize,
                            fileExtension: returnData[index].fileExtension,
                            fileFullName: returnData[index].fileName + '.' + returnData[index].fileExtension,
                            uploadedBy: returnData[index].createdBy,
                            uploadedByName: returnData[index].createdByName,
                            uploadedOn: this.getFormattedDate(returnData[index].createdOn),
                            fileType: returnData[index].fileType,
                            fileTypeName: this.getFileTypeName(returnData[index].fileType),
                            isDeleteEnable: (returnData[index].task_SNo == this._wfDetails.taskSerialNumber) && (returnData[index].createdBy == this.memberId) ? true : false,
                            urn: returnData[index].urn,
                            isStandardDrawingDocument: returnData[index].isStandardDrawingDocument
                        });
                    }
                });
        }

    }

    public downloadFile(dataItem: any) {
        this.loaderService.isLoading.next(true);

        this._fileService.DownloadFile({ libraryNumber: FileUploadLibrary.WorkflowDocument, fileId: dataItem.fileId, fileName: dataItem.fileFullName }).subscribe((res: any) => {
            this.loaderService.isLoading.next(false);
            const downloadLink = document.createElement("a");
            downloadLink.href = window.URL.createObjectURL(res);
            downloadLink.download = dataItem.fileFullName;
            downloadLink.click();
            document.body.removeChild(downloadLink);
        }, err => {
            this.loaderService.isLoading.next(false);
            this._notificationService.showToast("Error in downloading attachment, try after some time", "Warning");
        })
    }

    public deleteFile(dataItem: any) {
        if (this.wfInputDetails.schedule_Type != 3) {
            this._notificationService.showPopup('Are you sure to delete', 'Confirm').then(data => {
                if (data == 'yes') {
                    this._fileService.DeleteFile({ libraryNumber: FileUploadLibrary.WorkflowDocument, fileId: dataItem.fileId, fileName: dataItem.fileFullName }).subscribe((res: StandardOutputModel) => {
                        if (res.successCode === 200) {
                            this._notificationService.showToast(res.successMessage, "Success");
                        }
                        else {
                            this._notificationService.showToast(res.successMessage, "Warning");
                        }
                        this.populateFileUploadGrid();
                    });
                }
            });
        }
        else {
            this._notificationService.showToast("Cannot delete Standard Drawing documents", "Warning");
        }
    }

    public isShow_checklist_option!: boolean;
    public populateChecklistGrid() {
        this.workflowTemplateService.getWorkflowDocumentCheckist(this.wfInputDetails.documentId, this.wfInputDetails.revisionNo, this.wfInputDetails.workflowId).subscribe((data) => {
            data.forEach((each: any) => {
                each['clFullName'] = each['clShortName'] + ' - ' + each['clName'];
                each['deleteicon'] = (each.taskSerialNumber == this._wfDetails.taskSerialNumber) && (each.uploadedBy == this.memberId) ? true : false;
            });
            this.selectedChecklistCollection = data;
            this.isShow_checklist_option = this.selectedChecklistCollection.length > 0 ? false : true;
        });
    }

    public async getPreviousChecklist() {
        let input = {
            'doc_Id': this.wfInputDetails.documentId
        }
        this.PreviousChecklist = await this.workflowTemplateService.getChecklist(input).toPromise();

        let dialogRef = this.dialog.open(DocumentPreviousRevisionChecklistComponent, {
            panelClass: 'mat-dialog-secondary',
            width: '70%',
            data: this.PreviousChecklist
        });
        dialogRef.afterClosed().subscribe((res) => {
            if (res.length > 0) {
                this.reciviedChecklist = res.filter((data: any) => data.isSelected == true);
                this.reciviedChecklist.forEach(value => {
                    this.selectedChecklistCollection.push({
                        documentId: this.wfInputDetails.documentId,
                        documentNumber: this.wfInputDetails.documentNumber,
                        documentTitle: this.wfInputDetails.documentTitle,
                        documentRevisionNo: this.wfInputDetails.revisionNo,
                        deleteicon: true,
                        taskSerialNumber: this.wfInputDetails.taskSerialNumber,
                        memberId: this._commonService.getLoggedInUserId(),
                        workflowId: this.wfInputDetails.workflowId,
                        clId: value.cL_Id,
                        clRevisionNo: value.cL_Rev_No,
                        clName: value.cL_Description,
                        clShortName: value.cL_Short_Description,
                        clFullName: value.clFullName,
                        uploadedBy: this._commonService.getLoggedInUserId(),
                        uploadedByName: this._commonService.getLoggedInUserName(),
                        uploadedOn: new Date(),
                        is_previous_checklist: true
                    });
                })
                this.selectedChecklistCollection = this.getUnique(this.selectedChecklistCollection, 'clId');
                Array.prototype.push.apply(this.checklistCollection, this.selectedChecklistCollection);
                this.isShow_checklist_option = this.selectedChecklistCollection.length > 0 ? false : true;
            }
        });

    }

    getUnique(arr: any, comp: any) {
        // store the comparison  values in array
        const unique = arr.map((e: any) => e[comp])
            // store the indexes of the unique objects
            .map((e: any, i: any, final: any) => final.indexOf(e) === i && i)
            // eliminate the false indexes & return unique objects
            .filter((e: any) => arr[e]).map((e: any) => arr[e]);
        return unique;
    }

    public onChange_Checklist(event: any) {

        if (event.value != "-2")
            this.selectedChecklist = event.value;
        else
            this.selectedChecklist = 0;
    }

    public onclick_AddChecklist() {
        if (!this.addCheckList) {
            if (this.selectedChecklist == null || this.selectedChecklist <= 0) {
                this._notificationService.showToast('Please Select  Check List', "Warning");
                return;
            }
            let selectedCheckList: any = null;
            if (this.checklistCollection.filter((item: any) => item.clId == this.selectedChecklist).length > 0)
                selectedCheckList = this.checklistCollection.filter((item: any) => item.clId == this.selectedChecklist)[0];
            if (selectedCheckList) {
                if (this.selectedChecklistCollection.filter(x => x.clId == selectedCheckList.clId).length == 0)
                    this.selectedChecklistCollection.push({
                        documentId: this.wfInputDetails.documentId,
                        documentNumber: this.wfInputDetails.documentNumber,
                        documentTitle: this.wfInputDetails.documentTitle,
                        documentRevisionNo: this.wfInputDetails.revisionNo,
                        deleteicon: true,
                        taskSerialNumber: this.wfInputDetails.taskSerialNumber,
                        memberId: this._commonService.getLoggedInUserId(),
                        workflowId: this.wfInputDetails.workflowId,
                        clId: selectedCheckList.clId,
                        clRevisionNo: selectedCheckList.revisionNo,
                        clName: selectedCheckList.clDescription,
                        clShortName: selectedCheckList.clShortDescription,
                        clFullName: selectedCheckList.clFullDescription,
                        uploadedBy: this._commonService.getLoggedInUserId(),
                        uploadedByName: this._commonService.getLoggedInUserName(),
                        uploadedOn: new Date(),
                        is_previous_checklist: false
                    });
                // this.getChecklistData();  
            }
            this.isShow_checklist_option = this.selectedChecklistCollection.length > 0 ? false : true;
            this.selectedChecklist = -2;
        }
    }

    public async openChecklistItems(dataItem: any) {
        let assign = dataItem;
        let assignedvalue =
        {
            'documentId': assign.documentId,
            'documentRevisionNo': assign.documentRevisionNo,
            'memberId': assign.memberId,
            'clRevisionNo': assign.clRevisionNo,
            'workflowId': assign.workflowId,
            'taskSerialNumber': assign.taskSerialNumber,
            'currentTaskSerialNumber': this._wfDetails.taskSerialNumber
        }

        if (dataItem.is_previous_checklist == true) {
            let getprevious = this.PreviousChecklist.filter(x => x.cL_Description == dataItem.clName)[0];
            let workflownew =
            {
                'documentId': getprevious.doc_Id,
                'documentRevisionNo': getprevious.revision_No,
                'clId': getprevious.cL_Id,
                'clRevisionNo': getprevious.cL_Rev_No
            }

            this.checklistselectedvalue = [];
            this.checklistselectedvalue = await this.workflowTemplateService.getWorkflowChecklistItem(workflownew).toPromise();

            this.workflowTemplateService.getWorkflowDocumentCheckist(getprevious.doc_Id, getprevious.revision_No, this.checklistselectedvalue[0].workflowId).subscribe((data) => {
                data.forEach((each: any) => {
                    each['clFullName'] = each['clShortName'] + ' - ' + each['clName'];
                });
                this.previouswithvalue = data.filter((x: any) => x.clShortName == getprevious.cL_Short_Description)[0];
                let inputdata = this.previouswithvalue;

                let dialogRef = this.dialog.open(RespondWorflowChecklistItemsComponent, {
                    panelClass: 'mat-dialog-primary',
                    data: { inputdata, isReadMode: false, assignedvalue, isPerviousChecklist: dataItem.is_previous_checklist }
                });

                dialogRef.afterClosed().subscribe((data: any) => {
                    if (data) {
                        if (this.getpopupValue[0]) {
                            let itemToBeDelete = this.getpopupValue.filter((x: any) => x.currentpopupcl_Description == data.currentpopupcl_Description);

                            if (itemToBeDelete.length > 0)
                                this.getpopupValue.splice(this.getpopupValue.indexOf(itemToBeDelete), 1);
                        }
                        this.getpopupValue.push(data);
                    }
                    if (data.result == true) {
                        dataItem.is_previous_checklist = false;
                    }
                });
            });
        }

        // if(dataItem.is_previous_checklist == null || dataItem.is_previous_checklist == false)
        else {
            let inputdata = dataItem;
            let dialogRef = this.dialog.open(RespondWorflowChecklistItemsComponent, {
                panelClass: 'mat-dialog-primary',
                data: { inputdata, isReadMode: false, assignedvalue }
            });

            dialogRef.afterClosed().subscribe((data) => {
                if (data) {
                    if (this.getpopupValue[0]) {
                        let itemToBeDelete = this.getpopupValue.filter((x: { currentpopupcl_Description: any; }) => x.currentpopupcl_Description == data.currentpopupcl_Description);

                        if (itemToBeDelete.length > 0)
                            this.getpopupValue.splice(this.getpopupValue.indexOf(itemToBeDelete), 1);
                    }
                    this.getpopupValue.push(data);
                    if (data.copy_checklistItem) {
                        let i = this.selectedChecklistCollection.findIndex(x => x.clId == data.copy_checklistItem[0].clId && x.documentId == data.copy_checklistItem[0].documentId)
                        this.selectedChecklistCollection[i]["copy_checklistItem"] = data.copy_checklistItem;
                    }
                }
            });
        }
    }

    public deleteChecklist(dataItem: any) {
        if (dataItem.uploadedBy != this._commonService.getLoggedInUserId()) {
            this._notificationService.showToast('Checklist attached by another user, delete access restricted', "Warning");
            return;
        }

        this._notificationService.showPopup('Are you sure to delete', 'Confirm').then(data => {
            if (data == 'yes') {
                this.selectedChecklistCollection.forEach((value, index) => {
                    if (value.clId == dataItem.clId) {
                        this.workflowTemplateService.deleteWorkflowDocumentCheckist(dataItem.documentId, dataItem.documentRevisionNo, dataItem.clId, dataItem.clRevisionNo, this.memberId).subscribe(data => {
                            if (data["successCode"] == 200) {
                                this.selectedChecklistCollection.splice(index, 1);

                                if (this.getpopupValue[0]) {
                                    let itemToBeDelete = this.getpopupValue.filter((x: any) => x.currentpopupcl_Description == value.clName);

                                    if (itemToBeDelete.length > 0)
                                        this.getpopupValue.splice(this.getpopupValue.indexOf(itemToBeDelete), 1);
                                }
                                this._notificationService.showToast(data["successMessage"], "Success");
                                this.isShow_checklist_option = this.selectedChecklistCollection.length == 0 ? true : false;
                            }
                            else {
                                this._notificationService.showToast(data["successMessage"], "Warning");
                            }
                        });
                    }
                });
            }
        });
    }
    checklistItemList: any[] = [];

    public BulkSubmit(datalist: any): boolean | void {
        this.isForReAssignment = false;
        if (datalist && datalist._results.length > 0) {
            this.Postobj = [];

            for (let element of datalist._results) {

                if (!element.Actiondetails) {
                    let _docno = element._wfDetails.documentNumber;
                    this._notificationService.showToast(_docno + " - Please Select Action.", 'Warning');
                    return false;
                }

                let responce = this.bulk_action(element.Actiondetails, element.wfInputDetails, element);
                if (responce)
                    this.Postobj.push(responce);
                else {
                    this.Postobj = [];
                    return false;
                }
            }

            if (this.Postobj && this.Postobj.length > 0)
                this.Postobj.forEach(obj => {
                    this.Bulk_assignNextStep(obj._respondWorkflowDetails, obj.action, obj.Currentobj);
                });


        }


    }

    public onclick_action(action: WorkflowActionModel, getValue: any, doc_no = "") {

        if (action.action_Description.toUpperCase().includes('APPROVE') == true) {
            this.delayReasonValid = this.getFormValue('delayReasonDD', this.drForm);
            let drcomments: string = this.getFormValue('txtDRC', this.drForm);
            let ircomments: string = this.getFormValue('txtIRC', this.drForm);
            let ercomments: string = this.getFormValue('txtERC', this.drForm);

            if (this.isDueOnRequired && this.isDelayed && (this.delayReasonDD == undefined || this.delayReasonDD == 0 || this.delayReasonDD == -2)) {
                this.drForm.get('delayReasonDD')?.markAsTouched();
                this._notificationService.showToast("Delay Reason is mandatory.", 'Warning');
                return;
            }

            if (this.isDueOnRequired && this.isDelayed && this.delayReasonDD > 0) {
                if (this.delayReasonDD == 1 && ((!!drcomments && drcomments.length < 1) || (drcomments == null || drcomments == undefined))) {
                    this.drForm.get('txtDRC')?.markAsTouched();
                    this._notificationService.showToast("Delay Reason Comments is mandatory.", 'Warning');
                    return;
                }
                if (this.delayReasonDD == 2 && ((!!ircomments && ircomments.length < 1) || (ircomments == null || ircomments == undefined))) {
                    this.drForm.get('txtIRC')?.markAsTouched();
                    this._notificationService.showToast("Internal Reason Comments is mandatory.", 'Warning');
                    return;
                }

                if (this.delayReasonDD == 3 && ((!!ercomments && ercomments.length < 1) || (ercomments == null || ercomments == undefined))) {
                    this.drForm.get('txtERC')?.markAsTouched();
                    this._notificationService.showToast("External Reason  Comments is mandatory.", 'Warning');
                    return;
                }
            }

            if (this.isCompletedOnManulRequired && this.selectedCompletedOnDate == null) {
                this._notificationService.showToast("Completed on date selection is mandatory.", 'Warning');
                return;
            }

            let availableFileListForCurrentUser = this.fileCollection.filter(x => x.isDeleteEnable == true);
            if (this.isAttachmentRequired && availableFileListForCurrentUser.length <= 0) {
                this._notificationService.showToast("Attachment is mandatory.", 'Warning');
                return;
            }

            if (this.Checklist == "A") {
                if (this.isChecklistRequired && this.checklistCollection.length <= 0 && this.selectedChecklistCollection.length <= 0) {
                    this._notificationService.showToast("Checklist inclusion is mandatory.", 'Warning');
                    return;
                }
                if (this.isChecklistRequired && this.checklistCollection.length > 0) {
                    if (this.selectedChecklistCollection.length <= 0) {
                        this._notificationService.showToast("Checklist inclusion is mandatory", 'Warning');
                        return;
                    }
                    if (this.selectedChecklistCollection.length != 0) {
                        if (!this.getpopupValue[0]) {
                            this._notificationService.showToast("Some of the checklist included but not considered its items, please check", 'Warning');
                            return;
                        }

                        for (let i = 0; i < this.selectedChecklistCollection.length; i++) {
                            let isChecklistConsidered = this.getpopupValue.filter((x: any) => x.currentpopupcl_Description == this.selectedChecklistCollection[i]["clName"].toString() && x.checked_Allvalue == false).length;
                            if (isChecklistConsidered == 0) {
                                this._notificationService.showToast("Some of the checklist included but not considered its items, please check", 'Warning');
                                return;
                            }
                        }
                    }
                }
            }

            if (this.isCommentSheetRequired && (this.isCommentSheetno == null || this.isCommentSheetno.replace(/\s/g, "") == "")) {
                this._notificationService.showToast("Transmittal Number is mandatory.", 'Warning');
                return;
            }

            if (this.isTenderQuantityRequired && this.isQuantityApplicable.toUpperCase().trim() == 'A') {

                if (this.getTQpopupvalue == false) {

                    this._notificationService.showToast("Tender Quantity inclusion is mandatory.", 'Warning');

                    return;
                }
            }
        }
        else if (action.action_Description.toUpperCase().includes('HOLD') == true) {
            if (this.holdReason != null && this.holdReason != "") {
                let inputhold = {
                    doc_Id: getValue.documentId,
                    revision_No: getValue.revisionNo,
                    task_Sl_No: getValue.taskSerialNumber,
                    is_On_Hold: true,
                    holded_By: this.memberId,
                    holded_On: new Date(),
                    reason_for_Hold: this.holdReason
                };
                this.workflowTemplateService.holdWorkflow(inputhold).subscribe((res: StandardOutputModel) => {
                    if (res.successCode == 200) {
                        this._notificationService.showToast("Document Holded Successfully", 'Success');
                        this.closeTab.emit();
                        this.holdReason = null;
                    }
                    else {
                        this._notificationService.showToast("Error in Holding the Document", 'Error');
                    }
                });
                return;
            }
            else {
                this._notificationService.showToast("Holding Reason is Mandatory", 'Warning');
                return;
            }
        }

        if (this.Can_Update_DCI_Progress_Level && (this.SelectedProgressLevel == 0 || this.SelectedProgressLevel == -2)) {
            this._notificationService.showToast("Progress Level is mandatory.", 'Warning');
            return;
        }

        if (this.isApprovalStatusRequired && (this.selectedDocCategoryValue == 0 || this.selectedDocCategoryValue == -2)) {
            this._notificationService.showToast("Approval Status is mandatory.", 'Warning');
            return;
        }

        if (action.enable_Tag && !this.revForm.valid) {
            this._notificationService.showToast("Revise revision details are mandatory to fill.", 'Warning');
            return;
        }

        if (this.isDTNPreparation) {
            this._notificationService.showToast("Please complete this step through DTN Preparation page", 'Warning');
            return;
        }

        if (this.isDTNRelease) {
            this._notificationService.showToast("Please complete this step through DTN Release page", 'Warning');
            return;
        }

        this._notificationService.showPopup('Are you sure to perform the clicked action', 'Confirm').then(data => 
        {
            if (data == 'yes') {

                this.current_subWf = getValue.subWorkflow;
                this.next_subWf = action.next_Step_Sub_Workflow;
                this.supersede_enabled = action.enable_Tag==1 ? true : false;
                this.current_RevNo = getValue.revisionNo;
            

                if((this.current_subWf != null || undefined) && (this.next_subWf != null || undefined) && (this.current_subWf != this.next_subWf) )
                {
                    this.stageChange = true;
                    let next_subWf = action.next_Step_Sub_Workflow;
                    let dciRevisionList = this.dciRevisionList.filter(x => x.stageId == next_subWf);
                    this.next_RevNo = dciRevisionList[0].revisionNo ? dciRevisionList[0].revisionNo : null;
                }

                let currentActionDetails = this.currentWorkflowDetails.workflowAction.filter(item => item.task_Id == getValue.currentTaskId && item.action_Id == action.action_Id);
                let _respondWorkflowDetails: any = { "projectId": 0, "groupId": 0, respondWorkflowDetails: [], createdBy: 0, stageDetails: [] };
                let obj: any = {};
                obj["documentId"] = getValue.documentId;
                obj["revisionNumber"] = getValue.revisionNo;
                // obj["nextRevisionNumber"] = !this.isDocSetRequired ? this.revForm.get('formRevision')?.value : null;
                obj["nextRevisionNumber"] = (!this.isDocSetRequired ||  this.next_RevNo )? (this.supersede_enabled && !this.stageChange ? this.revForm.get('formRevision')?.value : this.next_RevNo) : null;
                obj["workflowId"] = getValue.workflowId;
                obj["TaskId"] = getValue.currentTaskId;
                obj["assignType"] = getValue.assignedType;
                obj["memberId"] = getValue.assignedToId;
                obj["actionPerformed"] = action.action_Id;
                obj["completedBy"] = this.memberId;
                obj["statusId"] = currentActionDetails[0].status_Id;
                obj["completedOn"] = this.isCompletedOnManulRequired ? this.selectedCompletedOnDate : null;
                obj["commentSheetNo"] = this.isCommentSheetno ? this.isCommentSheetno : null;
                obj["comments"] = getValue.comments;
                obj["delayReason"] = getValue.delayReason;
                obj["internalReason"] = getValue.internalReason;
                obj["externalReason"] = getValue.externalReason;
                obj["isFileAvailable"] = this.fileCollection.filter(x => x.isDeleteEnable == true).length > 0 ? true : false
                obj["taskSlNo"] = getValue.taskSerialNumber;
                obj["ProgressLevel"] = this.SelectedProgressLevel ? this.SelectedProgressLevel : null;

                _respondWorkflowDetails.projectId = getValue.projectId;
                _respondWorkflowDetails.groupId = getValue.groupId;
                _respondWorkflowDetails.createdBy = this.memberId;

                _respondWorkflowDetails.stageDetails = this.LatestStageDetails.map(x => { x.scheduled_On = this._datepipe.transform(x.scheduled_On, 'dd-MMM-yyyy'), x.revisedScheduled_On = (x.revisedScheduled_On ? this._datepipe.transform(x.revisedScheduled_On, 'dd-MMM-yyyy') : null), x.minScheduled_On = (x.minScheduled_On ? this._datepipe.transform(x.minScheduled_On, 'dd-MMM-yyyy') : null), x.maxScheduled_On = (x.maxScheduled_On ? this._datepipe.transform(x.maxScheduled_On, 'dd-MMM-yyyy') : null); return x });

                if (action.action_Description == 'Approve' && this.isTransmittalRequired) {
                    let dialogRef = this.dialog.open(CreateTransmittalComponent, {
                        panelClass: 'mat-dialog-primary',
                        data: { inputType: 'createTransmittal', doc_Id: getValue.documentId, revision_No: getValue.revisionNo, doc_No: getValue.documentNumber, doc_Title: getValue.documentTitle, selectedDispline: getValue.documentDisciplineId, is_Workflow: true, selectedList: [] },
                        autoFocus: false,
                        disableClose: true
                    });

                    dialogRef.afterClosed().subscribe((data) => {
                        if (data != null && data != undefined) {
                            obj["commentSheetNo"] = data;
                            _respondWorkflowDetails.respondWorkflowDetails.push(obj);
                            this.assignNextStep(_respondWorkflowDetails, action);
                        }
                        else {
                            this._notificationService.showToast("Failed to create Transmittal", "Warning");
                        }
                    });
                }
                else {
                    _respondWorkflowDetails.respondWorkflowDetails.push(obj);
                    this.assignNextStep(_respondWorkflowDetails, action);
                }
            }
        });
    }

    public assignNextStep(_respondWorkflowDetails: any, action: WorkflowActionModel) {
        this.show = false
        this.workflowTemplateService.postRespondWorkflowDetails(_respondWorkflowDetails).subscribe(data => {
            if (data["successCode"] == 200) {
                let isChangeUserPopupToShow = Boolean(JSON.parse(data["result"].toString().split(',')[0]));
                let _nextStepId = parseInt(JSON.parse(data["result"].toString().split(',')[1]));

                if (this.isApprovalStatusRequired) {
                    let docCategoryModel: IWFDocCategoryModel = {
                        docId: this.wfInputDetails.documentId,
                        revisionNo: this.wfInputDetails.revisionNo,
                        docCategory: this.selectedDocCategoryValue,
                        userId: this.memberId
                    }
                    this.workflowTemplateService.UpdateWorkflowDocumentCategory(docCategoryModel).subscribe((res: StandardOutputModel) => {
                        if (res.successCode == 500) {
                            this._notificationService.showToast(res.result, "Error");
                            return;
                        }
                    });
                }
                //Update No of Sheets
                if (this.isNoOfSheetsRequired) {
                    let noOfSheetsModel: IDCINoOfSheetsModel = {
                        docId: this.wfInputDetails.documentId,
                        revisionNo: this.wfInputDetails.revisionNo,
                        noOfSheets: this.wfInputDetails.noOfSheets,
                        userId: this.memberId
                    }
                    this.workflowTemplateService.UpdateDCINoOfSheets(noOfSheetsModel).subscribe((res: StandardOutputModel) => {
                        if (res.successCode == 500) {
                            this._notificationService.showToast(res.result, "Error");
                            return;
                        }
                    });
                }

                //update superseded revision details
                if (action.enable_Tag && this.revForm.valid) {
                    let supersedeRevDetails: IDCISupersedeRevDetailsModel = {
                        docId: this.wfInputDetails.documentId,
                        docStatus: this.revForm.get('dciStatus')?.value.dedId,
                        userId: this.memberId,
                        printSize: this.revForm.get('printSize')?.value.dedId,
                        revCategory: this.revForm.get('revCategory')?.value.revCategoryId,
                        comments: this.revForm.get('comments')?.value,
                        noOfSheets: this.revForm.get('noOfSheets')?.value == null ? 0 : this.revForm.get('noOfSheets')?.value
                    }
                    this._dciService.UpdateSupersedeRevisionDetails(supersedeRevDetails).subscribe((res: StandardOutputModel) => {
                        if (res.successCode == 500) {
                            this._notificationService.showToast("Failed to update supersede revision details", "Error");
                        }
                    })
                }

                let stepDetail: WorkflowTemplateStatusInputModel = this.currentWorkflowDetails.workflowStatus.filter(x => x.step_Id == _nextStepId)[0];

                let isSetpForReassignment: Boolean = stepDetail.is_Step_For_Reassignment;
                if (!!stepDetail && isChangeUserPopupToShow && this.isForReAssignment && isSetpForReassignment) {
                    let nextStepAssignedToRoles: WorkflowAssignedToModel[] = this.currentWorkflowDetails.workflowAssignedTo.filter(x => x.task_Id == stepDetail.task_Id && x.assign_Type == 1).filter(r => r.role_Id > 0);
                    let nextStepAssignedToMembers: WorkflowAssignedToModel[] = this.currentWorkflowDetails.workflowAssignedTo.filter(x => x.task_Id == stepDetail.task_Id && x.assign_Type == 1).filter(r => r.role_Id == 0 && r.member_Id > 0);
                   //other Discipline SH removal for B&f
                    if(stepDetail.workflow_Status_Description=="Other Discipline Approval" && this._commonService.getCurrentProjectDetails().icDescription=="BF - Buildings & Factories")
                    {
                        this._projService.getProjectElementDetails({
                            projectId: this.projectId,
                            groupId: this.groupId,
                            moduleId: Module.ScheduleDocument,
                            deDescription: 'Role'
                          }).subscribe((res: IProjectElementDetailsOutput[]) => {
                             if(res &&res.length>0&& res.some(x=>x.dedDescription.trim()=="Other Discipline SH"))
                             {
                                let otherDisciplineRole :any[]=[];
                                otherDisciplineRole.push({
                                   
                                       "workflow_Id": this.currentWorkflowDetails.workflowAssignedTo[0].workflow_Id,
                                       "task_Id": this.currentWorkflowDetails.workflowAssignedTo[0].task_Id,
                                       "member_Id": 0,
                                       "member_Name": "",
                                       "role_Id": res.filter(x=>x.dedDescription.trim()=="Other Discipline SH")[0].dedId,
                                       "role_Description": "Other Discipline Approval",
                                       "group_Id": this.currentWorkflowDetails.workflowAssignedTo[0].group_Id,
                                       "assign_Type": 1,
                                       "assign_Order": 1,
                                       "is_Active": true
                                   
                               });
                               let dialogrRef = this.dialog.open(WFActionAssignedToComponent, {
                                   panelClass: 'mat-dialog-secondary', width: '800px',
                                   data: { docId: this.wfInputDetails.documentId, docNo: this.wfInputDetails.documentNumber, revisionNo: this.wfInputDetails.revisionNo, docDiscipline: this.wfInputDetails.documentDisciplineId, docDisciplineDEId: this.wfInputDetails.documentDisciplineDEId, nextStep: stepDetail, assignedToRoles: otherDisciplineRole, assignedToMembers:  null, isReassign: false,
                                       "is_multi_disciplie_sh":true }, autoFocus: false, disableClose: true
                               });
                               dialogrRef.afterClosed().subscribe((x: any) => {
                                   this.afterDailogClose(x, data);
                               });
                             }
                             
                          });  
                        

                    }
                    //end
                   else if (!!nextStepAssignedToRoles && nextStepAssignedToRoles.length > 0) {
                        let dialogrRef = this.dialog.open(WFActionAssignedToComponent, {
                            panelClass: 'mat-dialog-secondary', width: '800px',
                            data: { docId: this.wfInputDetails.documentId, docNo: this.wfInputDetails.documentNumber, revisionNo: this.wfInputDetails.revisionNo, docDiscipline: this.wfInputDetails.documentDisciplineId, docDisciplineDEId: this.wfInputDetails.documentDisciplineDEId, nextStep: stepDetail, assignedToRoles: nextStepAssignedToRoles, assignedToMembers: nextStepAssignedToMembers && nextStepAssignedToMembers.length > 0 ? nextStepAssignedToMembers : null, isReassign: false }, autoFocus: false, disableClose: true
                        });
                        dialogrRef.afterClosed().subscribe((x: any) => {
                            this.afterDailogClose(x, data);
                        })
                    }
                    else if (!!nextStepAssignedToMembers && nextStepAssignedToMembers.length > 0) {
                        let dialogrRef = this.dialog.open(WFActionAssignedToComponent, {
                            panelClass: 'mat-dialog-secondary', width: '800px',
                            data: { docId: this.wfInputDetails.documentId, docNo: this.wfInputDetails.documentNumber, revisionNo: this.wfInputDetails.revisionNo, docDiscipline: this.wfInputDetails.documentDisciplineId, docDisciplineDEId: this.wfInputDetails.documentDisciplineDEId, nextStep: stepDetail, assignedToRoles: null, assignedToMembers: nextStepAssignedToMembers, isReassign: false }, autoFocus: false, disableClose: true
                        });
                        dialogrRef.afterClosed().subscribe((x: any) => {
                            this.afterDailogClose(x, data);
                        })
                    }
                    else {
                        this._notificationService.showToast(data["successMessage"], "Success");
                        this.closeTab.emit();
                    }
                }
                else {
                    this.SendMailOnActionCompletion(-1, stepDetail, data);
                }
            }
            else {
                this._notificationService.showToast(data["successMessage"], "Warning")
            }
            this.show = true;
        });
    }

    public SendMailOnActionCompletion(data: any, stepDetails: WorkflowTemplateStatusInputModel, successData: any, Currentobj?: any) {
        if (stepDetails) {
            let reqData: any = {
                projectId: this._commonService.getProjectId(),
                groupId: this.groupId,
                documentId: (Currentobj && Currentobj.wfInputDetails ? Currentobj.wfInputDetails.documentId : this.wfInputDetails.documentId),
                documentRevision: (Currentobj && Currentobj.wfInputDetails ? Currentobj.wfInputDetails.revisionNo : this.wfInputDetails.revisionNo),
                workflowId: stepDetails.workflow_Id,
                createdBy: this._commonService.getLoggedInUserId()
            };
            this.workflowTemplateService.SendMailOnActionCompletion(reqData).subscribe((res: StandardOutputModel) => {
                this.afterDailogClose(data, successData);
            })
        }
        else { /*For WF last step*/
            this.afterDailogClose(data, successData);
        }
    }

    public afterDailogClose(x: any, data: any) {
        if (!!x && x == "-1") {
            this._notificationService.showToast(data["successMessage"], "Success");
            if (this.Postobj && this.Postobj.length > 0)
                this.Postobj.shift();

            if (!this.Postobj || this.Postobj.length == 0)
                this.closeTab.emit();
        }
        else {
            if (!!x && x.successCode == 200) {
                this._notificationService.showToast(data["successMessage"], "Success");
                if (this.Postobj && this.Postobj.length > 0)
                    this.Postobj.shift();

                if (!this.Postobj || this.Postobj.length == 0)
                    this.closeTab.emit();
            }
            else {
                this._notificationService.showToast("Failed to update next step user", "Warning");
            }
        }
    }

    public viewFile(dataItem: any) {
        let dialogRef = this.dialog.open(ForgeViewerComponent, {
            panelClass: 'mat-dialog-primary',
            width: '900px',
            data: { fileUrn: dataItem.urn }
        });
    }

    public openTenderQuantity() {
        let dialogRef = this.dialog.open(WorkflowTenderQuantityComponent, {
            panelClass: 'mat-dialog-primary',
            height: '50',
            maxWidth: '60vw',
            autoFocus: false,
            disableClose: true,
            data: { documentId: this.wfInputDetails.documentId, docNo: this.wfInputDetails.documentNumber, revisionNo: this.wfInputDetails.revisionNo, isReadMode: false }
        });
        dialogRef.afterClosed().subscribe((data) => {
            if (data == true) {
                this.getTQpopupvalue = true;
            }
            else {
                this.getTQpopupvalue = false;
            }
        });
    }

    onQuantityChange(value: any) {
        this.isQuantityApplicable = value;
        if (value == "A") {
        }
    }

    checkListChange(value: any) {
        this.Checklist = value;
        this.addCheckList = value == "A" ? false : true;;
    }
    public getElementDetails(elementName: string, ModuleId?: number) {
        if (!ModuleId)
            ModuleId = Module.ScheduleDocument
        this._projService.getProjectElementDetails({ projectId: this.projectId, groupId: this.groupId, moduleId: ModuleId, deDescription: elementName })
            .subscribe((res: IProjectElementDetailsOutput[]) => {
                switch (elementName) {
                    case "Print Size":
                        this.printSizeList = res;
                        if (!!this.wfInputDetails.printSize) {
                            let printSize = this.printSizeList.filter(data => data.dedId == this.wfInputDetails.printSize)[0];
                            this.revForm.get('formPrintSize')?.setValue(printSize.dedDescription);
                            this.revForm.get('printSize')?.setValue(printSize);
                        }
                        break;
                    case "Status":
                        this.dciStatusList = res;
                        if (!!this.wfInputDetails.status) {
                            let status = this.dciStatusList.filter(data => data.dedId == this.wfInputDetails.status)[0];
                            this.revForm.get('formDciStatus')?.setValue(status.dedDescription);
                            this.revForm.get('dciStatus')?.setValue(status);
                        }
                        break;
                    case "Progress Level":
                        this.ProgressLevelsList = res;
                        break;
                    case "Document Category":
                        this.docCategoryList = res;
                        break;
                }
            }, err => { });
    }

    public GetProgressLevel(selectedText: any) {
        if (selectedText.value != '-2') {
            this.SelectedProgressLevel = selectedText.value;
        }
        else {
            this.SelectedProgressLevel = 0;
        }
    }

    public getDocCategoryValue(selectedText: any) {
        if (selectedText.value != '-2') {
            let obj = {
                "workflow_Id": this.wfInputDetails.workflowId,
                "task_Id": this.wfInputDetails.currentTaskId,
                "action_Id": 0,
                "category_Id": selectedText.value,
                "category_Description": selectedText.text,
                "is_Active": true
            }
            this.workflowTemplateService.getWorkflowCategory(obj).subscribe(data => {
                this.currentWorkflowDetails.workflowAction.forEach((val: any) => val["set_disable"] = true);
                if (!!data) {
                    data.forEach((element: any) => {
                        this.currentWorkflowDetails.workflowAction.forEach((val: any) => {
                            if (element.task_Id == this.wfInputDetails.currentTaskId) {
                                if (element.action_Id == val.action_Id) {
                                    val["set_disable"] = false;
                                }
                            }
                        })
                    });
                } else {
                    this.currentWorkflowDetails.workflowAction.forEach((val: any) => val["set_disable"] = false);
                }
                this.ListofActiondetails = this.currentWorkflowDetails.workflowAction.filter((val: any) => val.task_Id == this.wfInputDetails.currentTaskId && val["set_disable"] == false);
            })
        } else {
            this.currentWorkflowDetails.workflowAction.forEach((val: any) => val["set_disable"] = false);
            this.ListofActiondetails = this.currentWorkflowDetails.workflowAction.filter((val: any) => val.task_Id == this.wfInputDetails.currentTaskId && val["set_disable"] == false);
        }
        this.selectedDocCategoryValue = selectedText.value;
    }

    getFormValue(controlName: string, formGroup: FormGroup): any {
        return formGroup.get(controlName)?.value;
    }

    public onClick_WorkflowHistory(dataItem: any) {
        let dialogRef = this.dialog.open(ScheduleWorkflowhistoryComponent, {
            panelClass: 'mat-dialog-content',
            data: dataItem
        });

        dialogRef.afterClosed().subscribe((data) => {
        });
    }

    ShowICSpecific_Checklist() {
        if (this.isShowICSpecific) {
            this.getCheckList(this.wfInputDetails.groupId, this.wfInputDetails.documentDisciplineId, null, null, this.projectId);
        }
        else {
            this.getCheckList(this.wfInputDetails.groupId, this.wfInputDetails.documentDisciplineId, null, null, this.projectId);
        }
    }

    async getProjectStaticElements() {
        await this._projService.getProjectElements({ projectId: this.projectId, groupId: this.groupId, moduleId: Module.ScheduleDocument, IsQueryForStaticElement: true }).toPromise().then(
            (res: IProjectElementsOutput[]) => {
                if (res.length > 0) {
                    this.projectStaticElements = res;
                    let isDocSetRequiredElement = this.projectStaticElements.filter(x => x.elementDescription == "IsDocSetRequired")[0];
                    if (!!isDocSetRequiredElement) {
                        this.isDocSetRequired = isDocSetRequiredElement.isMandatory;
                    }
                }
            }, err => {
                this._notificationService.showToast("failed to get static element details", "Warning");
            });
    }

    setStageDate(selectedStageDate: any, stage: ILatestStageDetails) {
        stage.updatedScheduled_On = selectedStageDate.value;
    }



    public bulk_action(action: WorkflowActionModel, getValue: any, Currentobj: any): object | undefined | any {
        let _docno = Currentobj._wfDetails.documentNumber;
        //desc
        if (action.action_Description.toUpperCase().includes('APPROVE') == true) {
            Currentobj.delayReasonValid = this.getFormValue('delayReasonDD', Currentobj.drForm);
            let drcomments: string = this.getFormValue('txtDRC', Currentobj.drForm);
            let ircomments: string = this.getFormValue('txtIRC', Currentobj.drForm);
            let ercomments: string = this.getFormValue('txtERC', Currentobj.drForm);

            if (Currentobj.isDueOnRequired && Currentobj.isDelayed && (Currentobj.delayReasonDD == undefined || Currentobj.delayReasonDD == 0 || Currentobj.delayReasonDD == -2)) {
                Currentobj.drForm.get('delayReasonDD').markAsTouched();
                this._notificationService.showToast(_docno + " - Delay Reason is mandatory.", 'Warning');
                return;
            }

            if (Currentobj.isDueOnRequired && Currentobj.isDelayed && Currentobj.delayReasonDD > 0) {
                if (Currentobj.delayReasonDD == 1 && ((!!drcomments && drcomments.length < 1) || (drcomments == null || drcomments == undefined))) {
                    Currentobj.drForm.get('txtDRC').markAsTouched();
                    this._notificationService.showToast(_docno + " - Delay Reason Comments is mandatory.", 'Warning');
                    return;
                }
                if (Currentobj.delayReasonDD == 2 && ((!!ircomments && ircomments.length < 1) || (ircomments == null || ircomments == undefined))) {
                    Currentobj.drForm.get('txtIRC').markAsTouched();
                    this._notificationService.showToast(_docno + " - Internal Reason Comments is mandatory.", 'Warning');
                    return;
                }

                if (Currentobj.delayReasonDD == 3 && ((!!ercomments && ercomments.length < 1) || (ercomments == null || ercomments == undefined))) {
                    Currentobj.drForm.get('txtERC').markAsTouched();
                    this._notificationService.showToast(_docno + " - External Reason  Comments is mandatory.", 'Warning');
                    return;
                }
            }

            if (Currentobj.isCompletedOnManulRequired && Currentobj.selectedCompletedOnDate == null) {
                this._notificationService.showToast(_docno + " - Completed on date selection is mandatory.", 'Warning');
                return;
            }

            let availableFileListForCurrentUser = Currentobj.fileCollection.filter((x: any) => x.isDeleteEnable == true);
            if (Currentobj.isAttachmentRequired && availableFileListForCurrentUser.length <= 0) {
                this._notificationService.showToast(_docno + " - Attachment is mandatory.", 'Warning');
                return;
            }

            if (Currentobj.Checklist == "A") {
                if (Currentobj.isChecklistRequired && Currentobj.checklistCollection.length <= 0 && Currentobj.selectedChecklistCollection.length <= 0) {
                    this._notificationService.showToast(_docno + " - Checklist inclusion is mandatory.", 'Warning');
                    return;
                }
                if (Currentobj.isChecklistRequired && Currentobj.checklistCollection.length > 0) {
                    if (Currentobj.selectedChecklistCollection.length <= 0) {
                        this._notificationService.showToast(_docno + " - Checklist inclusion is mandatory", 'Warning');
                        return;
                    }
                    if (Currentobj.selectedChecklistCollection.length != 0) {

                        if (!this.is_checklistCopied) {
                            if (!Currentobj.getpopupValue[0]) {
                                this._notificationService.showToast(_docno + " - Some of the checklist included but not considered its items, please check", 'Warning');
                                return;
                            }

                            for (let i = 0; i < Currentobj.selectedChecklistCollection.length; i++) {
                                let isChecklistConsidered = Currentobj.getpopupValue.filter((x: any) => x.currentpopupcl_Description == Currentobj.selectedChecklistCollection[i]["clName"].toString() && x.checked_Allvalue == false).length;
                                if (isChecklistConsidered == 0) {
                                    this._notificationService.showToast(_docno + " - Some of the checklist included but not considered its items, please check", 'Warning');
                                    return;
                                }
                            }
                        }
                    }

                }
            }

            if (Currentobj.isCommentSheetRequired && (Currentobj.isCommentSheetno == null || Currentobj.isCommentSheetno.replace(/\s/g, "") == "")) {
                this._notificationService.showToast(_docno + " - Transmittal Number is mandatory.", 'Warning');
                return;
            }

            if (Currentobj.isTenderQuantityRequired && Currentobj.isQuantityApplicable.toUpperCase().trim() == 'A') {

                if (Currentobj.getTQpopupvalue == false) {

                    this._notificationService.showToast(_docno + " - Tender Quantity inclusion is mandatory.", 'Warning');

                    return;
                }
            }
        }

        if (Currentobj.Can_Update_DCI_Progress_Level && (Currentobj.SelectedProgressLevel == 0 || Currentobj.SelectedProgressLevel == -2)) {
            this._notificationService.showToast(_docno + " - Progress Level is mandatory.", 'Warning');
            return;
        }

        if (Currentobj.isApprovalStatusRequired && (Currentobj.selectedDocCategoryValue == 0 || Currentobj.selectedDocCategoryValue == -2)) {
            this._notificationService.showToast(_docno + " - Approval Status is mandatory.", 'Warning');
            return;
        }

        if (action.enable_Tag && !Currentobj.revForm.valid) {
            this._notificationService.showToast(_docno + " - Revise revision details are mandatory to fill.", 'Warning');
            return;
        }

        if (Currentobj.isDTNPreparation) {
            this._notificationService.showToast(_docno + " - Please complete step through DTN Preparation page", 'Warning');
            return;
        }

        if (Currentobj.isDTNRelease) {
            this._notificationService.showToast(_docno + " - Please complete  step through DTN Release page", 'Warning');
            return;
        }

        // Currentobj._notificationService.showPopup('Are you sure to perform the clicked action', 'Confirm').then(data => {
        //  if (data == 'yes') {

        this.current_subWf = getValue.subWorkflow;
        this.next_subWf = action.next_Step_Sub_Workflow;
        this.supersede_enabled = action.enable_Tag==1 ? true : false;
        this.current_RevNo = getValue.revisionNo;
    

        if((this.current_subWf != null || undefined) && (this.next_subWf != null || undefined) && (this.current_subWf != this.next_subWf) )
        {
            this.stageChange = true;
            let next_subWf = action.next_Step_Sub_Workflow;
            let dciRevisionList = this.dciRevisionList.filter(x => x.stageId == next_subWf);
            this.next_RevNo = dciRevisionList[0].revisionNo ? dciRevisionList[0].revisionNo : null;
        }

        let currentActionDetails = Currentobj.currentWorkflowDetails.workflowAction.filter((item: any) => item.task_Id == getValue.currentTaskId && item.action_Id == action.action_Id);
        let _respondWorkflowDetails: any = { "projectId": 0, "groupId": 0, respondWorkflowDetails: [], createdBy: 0, stageDetails: [] };
        let obj: any = {};
        obj["documentId"] = getValue.documentId;
        obj["revisionNumber"] = getValue.revisionNo;
        // obj["nextRevisionNumber"] = !Currentobj.isDocSetRequired ? Currentobj.revForm.get('formRevision').value : null;
        obj["nextRevisionNumber"] = ( !Currentobj.isDocSetRequired || this.next_RevNo ) ? (this.supersede_enabled && !this.stageChange ? Currentobj.revForm.get('formRevision')?.value : this.next_RevNo) : null;
        obj["workflowId"] = getValue.workflowId;
        obj["TaskId"] = getValue.currentTaskId;
        obj["assignType"] = getValue.assignedType;
        obj["memberId"] = Currentobj.memberId; getValue.assignedToId;
        obj["actionPerformed"] = action.action_Id;
        obj["completedBy"] = Currentobj.memberId;
        obj["statusId"] = currentActionDetails[0].status_Id;
        obj["completedOn"] = this.isCompletedOnManulRequired ? Currentobj.selectedCompletedOnDate : null;
        obj["commentSheetNo"] = Currentobj.isCommentSheetno ? Currentobj.isCommentSheetno : null;
        obj["comments"] = getValue.comments;
        obj["delayReason"] = getValue.delayReason;
        obj["internalReason"] = getValue.internalReason;
        obj["externalReason"] = getValue.externalReason;
        obj["isFileAvailable"] = Currentobj.fileCollection.filter((x: any) => x.isDeleteEnable == true).length > 0 ? true : false
        obj["taskSlNo"] = getValue.taskSerialNumber;
        obj["ProgressLevel"] = Currentobj.SelectedProgressLevel ? Currentobj.SelectedProgressLevel : null;

        _respondWorkflowDetails.projectId = getValue.projectId;
        _respondWorkflowDetails.groupId = getValue.groupId;
        _respondWorkflowDetails.createdBy = Currentobj.memberId;
        _respondWorkflowDetails.stageDetails = Currentobj.LatestStageDetails;

        if (action.action_Description == 'Approve' && Currentobj.isTransmittalRequired) {
            let dialogRef = this.dialog.open(CreateTransmittalComponent, {
                panelClass: 'mat-dialog-primary',
                data: { inputType: 'createTransmittal', doc_Id: getValue.documentId, revision_No: getValue.revisionNo, doc_No: getValue.documentNumber, doc_Title: getValue.documentTitle, selectedDispline: getValue.documentDisciplineId, is_Workflow: true, selectedList: [] },
                autoFocus: false,
                disableClose: true
            });

            dialogRef.afterClosed().subscribe((data) => {
                if (data != null && data != undefined) {
                    obj["commentSheetNo"] = data;
                    _respondWorkflowDetails.respondWorkflowDetails.push(obj);
                    //this.assignNextStep(_respondWorkflowDetails, action);
                }
                else {
                    this._notificationService.showToast(_docno + " - Failed to create Transmittal", "Warning");
                }
            });
        }
        else {
            _respondWorkflowDetails.respondWorkflowDetails.push(obj);
            //this.assignNextStep(_respondWorkflowDetails, action);
        }
        let postdata = {
            "_respondWorkflowDetails": _respondWorkflowDetails,
            "action": action,
            "Currentobj": Currentobj
        }
        return postdata;
        //}
        // });
    }
    public Bulk_assignNextStep(_respondWorkflowDetails: any, action: WorkflowActionModel, Currentobj: any) {
        this.workflowTemplateService.postRespondWorkflowDetails(_respondWorkflowDetails).subscribe(data => {
            if (data["successCode"] == 200) {
                let isChangeUserPopupToShow = Boolean(JSON.parse(data["result"].toString().split(',')[0]));
                let _nextStepId = parseInt(JSON.parse(data["result"].toString().split(',')[1]));

                if (Currentobj.isApprovalStatusRequired) {
                    let docCategoryModel: IWFDocCategoryModel = {
                        docId: Currentobj.wfInputDetails.documentId,
                        revisionNo: Currentobj.wfInputDetails.revisionNo,
                        docCategory: Currentobj.selectedDocCategoryValue,
                        userId: Currentobj.memberId
                    }
                    this.workflowTemplateService.UpdateWorkflowDocumentCategory(docCategoryModel).subscribe((res: StandardOutputModel) => {
                        if (res.successCode == 500) {
                            this._notificationService.showToast(res.result, "Error");
                            return;
                        }
                    });
                }
                //Update No of Sheets
                if (Currentobj.isNoOfSheetsRequired) {
                    let noOfSheetsModel: IDCINoOfSheetsModel = {
                        docId: Currentobj.wfInputDetails.documentId,
                        revisionNo: Currentobj.wfInputDetails.revisionNo,
                        noOfSheets: Currentobj.wfInputDetails.noOfSheets,
                        userId: Currentobj.memberId
                    }
                    this.workflowTemplateService.UpdateDCINoOfSheets(noOfSheetsModel).subscribe((res: StandardOutputModel) => {
                        if (res.successCode == 500) {
                            this._notificationService.showToast(res.result, "Error");
                            return;
                        }
                    });
                }

                //update superseded revision details
                if (action.enable_Tag && Currentobj.revForm.valid) {
                    let supersedeRevDetails: IDCISupersedeRevDetailsModel = {
                        docId: Currentobj.wfInputDetails.documentId,
                        docStatus: Currentobj.revForm.get('dciStatus').value.dedId,
                        userId: Currentobj.memberId,
                        printSize: Currentobj.revForm.get('printSize').value.dedId,
                        revCategory: Currentobj.revForm.get('revCategory').value.revCategoryId,
                        comments: Currentobj.revForm.get('comments').value,
                        noOfSheets: Currentobj.revForm.get('noOfSheets').value == null ? 0 : Currentobj.revForm.get('noOfSheets').value
                    }
                    this._dciService.UpdateSupersedeRevisionDetails(supersedeRevDetails).subscribe((res: StandardOutputModel) => {
                        if (res.successCode == 500) {
                            this._notificationService.showToast("Failed to update supersede revision details", "Error");
                        }
                    })
                }

                let stepDetail: WorkflowTemplateStatusInputModel = Currentobj.currentWorkflowDetails.workflowStatus.filter((x: any) => x.step_Id == _nextStepId)[0];


                this.SendMailOnActionCompletion(-1, stepDetail, data, Currentobj);

            }
            else {
                this._notificationService.showToast(data["successMessage"], "Warning")
            }
        });
    }
    public OnselectionChange(selectedText: any) {
        if (selectedText && selectedText.additionalValues)
            this.Actiondetails = selectedText.additionalValues.additionalValues
    }

    public EmitCopyDetails() {
        let _data = { selectedChecklistCollection: this.selectedChecklistCollection, wfInputDetails: this.wfInputDetails }
        this.CopyDetails.emit(_data);
    }

}